import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import OperationsSidebar from "../OperationsSidebar/OperationsSidebar";

const OperationsLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<OperationsSidebar />}>{children}</NavigationBar>
);

export default OperationsLayout;
